import ApiClient from "@/api/ApiClient.ts";

const actions = {
  async getInvoiceById(_, customParams) {
    const params = {
      ...customParams,
    };

    try {
      let response = await ApiClient().get("invoices", {
        params,
        responseType: params.output !== "json" ? "blob" : undefined,
      });
      return response.data;
    } catch (error) {
      console.error("ERROR en getInvoicesById: ", error.message);
    }
  },

  /**
   * Updates an invoice
   * @param _
   * @param {{ wgId: Number, id: Number, data: Object}} payload
   * @returns {Promise<any>}
   */
  async updateInvoice(_, { wgId, id, data }) {
    try {
      let response = await ApiClient().put("invoices", data, {
        params: {
          wgId,
          id,
        },
      });
      return response.data;
    } catch (error) {
      console.error("ERROR en updateInvoice: ", error.message);
    }
  },

  async getInvoiceSendEmail(_, customParams) {
    const params = {
      ...customParams,
    };

    try {
      await ApiClient().get("invoices/sendEmail", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en getInvoicesRemittancesSendEmail: ", error.message);
      return false;
    }
  },

  async getInvoicesRemittances(_, customParams) {
    const params = {
      ...customParams,
    };

    try {
      let response = await ApiClient().get("invoices/remittance", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("ERROR en getInvoicesRemittances: ", error.message);
    }
  },

  async createInvoicesRemittance(_, payload) {
    const params = {
      ...payload.params,
    };
    if (payload.data.from) {
      payload.data.from /= 1000;
    }
    if (payload.data.to) {
      payload.data.to /= 1000;
    }
    if (payload.data.subscribers[0] === 0) {
      payload.data.subscribers = [];
    }
    try {
      await ApiClient().post("invoices/remittance", payload.data, {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en createInvoicesRemittance: ", error.message);
      return false;
    }
  },

  async deleteInvoicesRemittance(_, params) {
    try {
      await ApiClient().delete("invoices/remittance", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en deleteInvoicesRemittance: ", error);
      return false;
    }
  },

  async getInvoicesRemittancesGenerate(_, customParams) {
    const params = {
      ...customParams,
    };

    try {
      let { data } = await ApiClient().get("invoices/remittance/generateInvoices", {
        params,
      });
      return data;
    } catch (error) {
      console.error("ERROR en getInvoicesRemittancesGenerate: ", error.response.status);
      return false;
    }
  },

  async getInvoicesRemittancesSendEmail(_, customParams) {
    const params = {
      ...customParams,
    };

    try {
      await ApiClient().get("invoices/remittance/sendEmail", {
        params,
      });
      return true;
    } catch (error) {
      console.error("ERROR en getInvoicesRemittancesSendEmail: ", error.message);
      return false;
    }
  },
};

export default {
  namespaced: true,
  actions,
};
